export default __webpack_public_path__ + "static/media/jungle.bc0d71b6.jpg";